import Button from 'components/button/Button';
import { black, blue, textGray, white } from 'modules/colors';
import media from 'modules/media';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

export const WhatWeProvide = styled.div`
  padding: ${spacing.xl}px;
  padding-bottom: 0;
  max-width: 1280px;
  margin: 0 auto;
`;

export const SectionsTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const SectionsTitle = styled.h1`
  font-size: ${fonts.xl}px;
  color: ${(props) => (props.color === 'black' ? black : white)};
  margin-top: ${spacing.xl}px;
`;

export const SubTitle = styled.h2`
  color: ${blue};
  font-size: ${fonts.sm}px;
`;

export const TitleLine = styled.hr`
  background-color: ${(props) => (props.color === 'gray' ? textGray : white)};
  height: 2px;
  border: 0;
  width: 100%;
  margin: ${spacing.md}px 0 ${spacing.xl}px 0;
`;

export const WhatWeProvideContent = styled.div`
  display: flex;
  padding: ${spacing.xl}px 0;
  justify-content: space-between;

  ${media.desktop} {
    width: 100%;
    flex-direction: column;
    padding: ${spacing.xl}px;
    align-items: center;
  }

  ${media.phone} {
    padding: 0;
  }
`;

export const BulletsPoints = styled.div`
  width: 50%;
  display: inline-block;
  flex-wrap: wrap;
  align-items: center;

  ${media.desktop} {
    width: 100%;
    flex-direction: column;
  }
`;

export const BulletPoint = styled.div`
  display: inline-flex;
  width: 50%;
  padding: ${spacing.lg}px 0;
  align-items: center;

  ${media.desktop} {
    width: 100%;
  }
`;

export const Bullet = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: ${black};
  color: white;
  border-radius: 50%;
  margin-right: ${spacing.lg}px;
  font-size: ${fonts.lg}px;
`;

export const BulletText = styled.div`
  font-size: ${fonts.md}px;
  color: ${black};
  margin: 0 ${spacing.lg}px;
  flex: 1;
  line-height: 18px;
`;

export const ScreenImage = styled.img`
  width: 511px;
  height: 362px;

  ${media.bigDesktop} {
    width: 400px;
    height: 283px;
  }

  ${media.desktop} {
    margin-top: ${spacing.xl}px;
  }

  ${media.tablet} {
    width: 340px;
    height: 230px;
  }

  ${media.phone} {
    width: 280px;
    height: 189px;
  }
`;

export const QuoteWrapper = styled.div`
  margin-top: 128px;

  ${media.bigDesktop} {
    padding: 0 ${spacing.xl}px;
  }

  ${media.phone} {
    margin-top: 64px;
  }
`;

export const ButtonStyled = styled(Button)`
  margin: 0 auto;
  margin-top: 32px;
`;
